<div class="overflow-hidden rounded-2xl border border-slate-200 bg-white">
    <div class="table-responsive">
        <table>
            <thead>
                <tr>
                    <th>
                        <app-table-order-column
                            label="translate_type"
                            orderByColumnName="contentType"
                            [tableController]="tableController"
                        ></app-table-order-column>
                    </th>
                    <th>
                        <app-table-order-column
                            label="translate_name"
                            orderByColumnName="name"
                            [tableController]="tableController"
                        ></app-table-order-column>
                    </th>
                    <th>
                        <app-table-order-column
                            label="translate_file_size"
                            orderByColumnName="fileSize"
                            [tableController]="tableController"
                        ></app-table-order-column>
                    </th>
                    <th>{{ 'translate_usage_count' | translate }}</th>
                    <th>{{ 'translate_tags' | translate }}</th>
                    <th>
                        <app-table-order-column
                            label="translate_creation_time"
                            orderByColumnName="creationTime"
                            [tableController]="tableController"
                        ></app-table-order-column>
                    </th>
                    <th>
                        <app-table-order-column
                            label="translate_last_update"
                            orderByColumnName="latestModificationTime"
                            [tableController]="tableController"
                        ></app-table-order-column>
                    </th>
                    @for (field of customFields; track field) {
                        <th>
                            {{ field.name | translate }}
                        </th>
                    }
                </tr>
            </thead>

            <tbody>
                @for (item of tableController.items; track item) {
                    <tr>
                        <!-- Type -->
                        <td class="align-middle">
                            <app-library-file-icon
                                [libraryFile]="item"
                            ></app-library-file-icon>
                        </td>
                        <!-- Name -->
                        <td class="align-middle">
                            <app-library-file-name
                                [libraryFile]="item"
                            ></app-library-file-name>
                        </td>
                        <!-- File size -->
                        <td class="text-center align-middle">
                            @if (item.fileSize) {
                                <span class="text-sm text-slate-400">
                                    {{ item.fileSize | fileSize }}
                                </span>
                            }
                        </td>
                        <!-- Usage count -->
                        <td class="text-center align-middle">
                            @if (item.usageCount !== 0) {
                                <a
                                    class="cursor-pointer"
                                    (click)="showLinkedResourcesDialog(item)"
                                >
                                    {{ item.usageCount }}
                                </a>
                            }
                            @if (item.usageCount === 0) {
                                {{ item.usageCount }}
                            }
                        </td>
                        <!-- Tags -->
                        <td class="w-40">
                            <div
                                class="flex flex-row flex-wrap items-center justify-center gap-1"
                            >
                                @for (tag of item.tags; track tag) {
                                    <button
                                        (click)="tagClick.emit(tag)"
                                        class="inline-flex items-center rounded-full bg-emerald-50 px-2 py-0.5 text-xs font-medium text-emerald-700 transition-colors hover:bg-emerald-100"
                                    >
                                        {{ tag.name }}
                                    </button>
                                }
                            </div>
                        </td>
                        <!-- Creation time -->
                        <td class="text-center align-middle text-slate-500">
                            {{
                                item.creationTime
                                    | toDate
                                    | dfnsFormatDistanceToNow
                            }}
                            <!-- Owner -->
                            <p class="text-sm text-slate-400">
                                {{
                                    'translate_by_name'
                                        | translate
                                            : {
                                                  name: item.owner.name,
                                              }
                                }}
                            </p>
                        </td>
                        <!-- Latest update -->
                        <td class="text-center align-middle text-slate-500">
                            {{
                                item.latestModificationTime
                                    | toDate
                                    | dfnsFormatDistanceToNow
                            }}
                            <!-- Username -->
                            @if (item.latestModificationBy) {
                                <div class="text-sm text-slate-400">
                                    {{
                                        'translate_by_name'
                                            | translate
                                                : {
                                                      name: item.latestModificationBy,
                                                  }
                                    }}
                                </div>
                            }
                        </td>
                        <!-- Custom fields -->
                        @for (field of customFields; track field) {
                            <td class="text-center">
                                <ng-container
                                    [ngTemplateOutlet]="field.template"
                                    [ngTemplateOutletContext]="{ item }"
                                ></ng-container>
                            </td>
                        }
                    </tr>
                }
            </tbody>
        </table>
    </div>
</div>
